// src/modules/wiring/hooks/useFloorTransitionArrow.js
//
// Kat-geçiş oku — preview ok'unu çizim sırasında mouse'a (wire ucuna) takip ettirir.
// Ok useComponentWiring keydown'ında oluşturuluyor (floorTransition.updateFloorArrowPreview)
// ama orada bir kez konuyor; bu hook rAF ile her frame ok'u base.previewEndPointRef'e
// taşır ve component preview'ı gizler → ok mouse'la birlikte gelir.
//
// KABLO BACASI: baca içinde ok'un konumu/lifecycle'ı useComponentWiring'in kendi
// mantığına ait (exit point snap'i). Regresyonu önlemek için baca içindeyken bu hook
// HİÇBİR ŞEY yapmaz (isInsideCableShaftRef guard).

import { useEffect } from 'react';

export default function useFloorTransitionArrow({
  scene,
  base,
  arrowPreviewRef,
  arrowPreviewActiveRef,
  isInsideCableShaftRef,
}) {
  useEffect(() => {
    if (!scene || !base) return;
    let rafId = null;

    const tick = () => {
      rafId = requestAnimationFrame(tick);
      // Baca içinde: dokunma (useComponentWiring kendi yönetir)
      if (isInsideCableShaftRef?.current) return;
      if (!arrowPreviewActiveRef?.current) return;

      const arrow = arrowPreviewRef?.current;
      const p = base.previewEndPointRef?.current;
      if (!arrow || !p) return;

      // Ok'u wire ucuna taşı (mouse'u takip etsin)
      arrow.position.set(p.x, p.y, 0.3);
      // Component preview'ı tamamen gizle (ok onun yerine görünür)
      if (base.previewSymbolRef?.current) base.previewSymbolRef.current.visible = false;
    };

    rafId = requestAnimationFrame(tick);
    return () => { if (rafId != null) cancelAnimationFrame(rafId); };
  }, [scene, base, arrowPreviewRef, arrowPreviewActiveRef, isInsideCableShaftRef]);
}
